import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { Payout } from './payout';

@inheritSerialization(AbstractModel)
export class DriverBankSummary extends AbstractModel {

  @autoserialize
  driverId: number;

  @autoserialize
  driverBankId: number;

  @autoserialize
  currentBalance: number;

  @autoserialize
  monthToDateCommissionCredits: number;

  @autoserialize
  monthToDateCancellationCredits: number;

  @autoserialize
  monthToDateCancellationDebits: number;

  @autoserialize
  monthToDatePayouts: number;

  @autoserialize
  weeklyPayoutTotal: number;

  @autoserialize
  weeklyPayoutLimit: number;

  @autoserialize
  availablePayoutAmount: number;

  @autoserializeAs(Payout)
  mostRecentPayout: Payout;

}

